import { AsyncPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { Observable } from 'rxjs';
import { AppService } from 'src/app/services/app.service';
import { SideBarMenuService } from 'src/app/services/sidebar-menu.service';

@Component({
  selector: 'app-app-detail',
  standalone: true,
  imports: [BreadcrumbModule, AsyncPipe],
  templateUrl: './app-detail.component.html',
})
export class AppDetailComponent implements OnInit {
  appName: string = localStorage.getItem('appName');
  appId: string = localStorage.getItem('appId');
  home: MenuItem;
  breadcrumbItems: MenuItem[] = [];
  entityCounts$: Observable<{ users: number; clinics: number; specialists: number }>;
  private sidebarMenuService = inject(SideBarMenuService);
  private appService = inject(AppService);

  ngOnInit(): void {
    this.entityCounts$ = this.appService.countEntitiesByAppId(this.appId);
    this.home = {
      icon: 'pi pi-fw pi-mobile',
      routerLink: '/',
      command: () => this.sidebarMenuService.clearSessionStorage(),
    };
    this.breadcrumbItems = [{ label: this.appName, styleClass: 'font-bold' }];
  }
}
